import { createSelector } from '@reduxjs/toolkit';

export const themeBlackStatus = (state: ReturnType<any>) => state.themeBlack.value;

export const themeBlackSelector = createSelector(themeBlackStatus, (state) => state);
